import posthog from 'posthog-js'
import { getDevice, relancerTwilio } from '@/lib/twilioDeviceSingleton'
import { getPdDevice } from '@/lib/twilioPdDeviceSingleton'
import { relancerTelnyx, telnyxPret } from '@/lib/voix/telnyx'
import { useEtatTelephoneStore } from '@/stores/useEtatTelephoneStore'
import { useTabStateStore } from '@/stores/useTabStateStore'

type Fournisseur = 'twilio' | 'telnyx'

/** Can this phone place a call right now? */
export function telephonePret(fournisseur: Fournisseur, powerDialer = false): boolean {
  if (powerDialer) return getPdDevice()?.state === 'registered'
  return fournisseur === 'telnyx' ? telnyxPret() : getDevice()?.state === 'registered'
}

/**
 * A call is placed while the phone is not ready: bring it back now and wait a
 * few seconds, instead of only telling the agent to try again. True when the
 * phone became ready in time.
 */
export async function attendreTelephonePret(
  fournisseur: Fournisseur,
  powerDialer = false,
  delaiMs = 8000,
): Promise<boolean> {
  if (!powerDialer) {
    if (fournisseur === 'telnyx') relancerTelnyx()
    else relancerTwilio()
  }
  const fin = Date.now() + delaiMs
  while (Date.now() < fin) {
    if (telephonePret(fournisseur, powerDialer)) return true
    await new Promise((resolve) => setTimeout(resolve, 250))
  }
  return telephonePret(fournisseur, powerDialer)
}

/**
 * Records that the agent saw "Phone not connected", with the phone's state, to
 * learn how often it happens and why (PostHog). No personal data.
 */
export function noterTelephonePasPret(fournisseur: Fournisseur, powerDialer = false): void {
  try {
    const etats = useEtatTelephoneStore.getState()
    posthog.capture('telephone_pas_pret', {
      fournisseur: powerDialer ? 'twilio_power_dialer' : fournisseur,
      etat: fournisseur === 'telnyx' ? etats.telnyx : etats.twilio,
      etat_twilio_sdk: (powerDialer ? getPdDevice() : getDevice())?.state ?? 'absent',
      onglet_actif: useTabStateStore.getState().isActive,
      onglet_visible: typeof document !== 'undefined' ? document.visibilityState === 'visible' : null,
      en_ligne: typeof navigator !== 'undefined' ? navigator.onLine : null,
    })
  } catch {
    // PostHog missing (local dev, ad blocker): carry on quietly.
  }
}
